import Vue from 'vue';
import VueTippy, { TippyComponent } from 'vue-tippy';

/**
 * USAGE: https://kabbouchi.github.io/vue-tippy/4.0/features/default.html
 */

Vue.use(VueTippy, {
  directive: 'tippy', // => v-tippy
  // popperOptions: {
  //   modifiers: {
  //     preventOverflow: {
  //       enabled: false,
  //     },
  //   },
  // },
});

Vue.component('tippy', TippyComponent);

window.addEventListener('scroll', () => {
  const popper = document.querySelectorAll('.tippy-popper');
  if (popper.length > 0) {
    [...popper].map((p) => {
      const instance = p._tippy;
      if (instance.state.isVisible) {
        instance.hide();
      }
    });
  }
});
